import { newestUnreadTicket } from '@/modules/support/store'
import { getHelpState } from './store'

// An unread reply is what the user came for, so it beats the ask surface.
// Every "Get help" entry point routes through here so they cannot drift apart.
export const openHelp = () => {
  const { actions } = getHelpState()
  const unreadTicket = newestUnreadTicket()
  if (unreadTicket) actions.openTickets(unreadTicket.publicId)
  else actions.open()
}
